import { useState, useEffect, useCallback } from 'react';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useCollapsedColumns } from '../board-collapse-columns-old';
import { useColumns } from '../columns-old';
import { useGroupBy } from '../group-by';

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const useCollapseAllColumns = () => {
	const [, setCollapseAllColumns] = useCollapsedColumns();
	const groupColumns = useColumns();

	const expandAllColumns = useCallback(() => {
		const columnKeys = groupColumns.map((column) => column.groupKey ?? '');
		setCollapseAllColumns(columnKeys, false);
	}, [groupColumns, setCollapseAllColumns]);

	const collapseAllColumns = useCallback(() => {
		const columnKeys = groupColumns.map((column) => column.groupKey ?? '');
		setCollapseAllColumns(columnKeys, true);
	}, [groupColumns, setCollapseAllColumns]);

	return { collapseAllColumns, expandAllColumns };
};

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
export const useCollapseColumn = ({ groupKey }: { groupKey: string | void }) => {
	const [groupBy] = useGroupBy();
	const [, setCollapsedColumns] = useCollapsedColumns();

	const { createAnalyticsEvent } = useAnalyticsEvents();

	const expandColumn = useCallback(
		(event?: MouseEvent) => {
			if (event?.stopPropagation) event.stopPropagation();
			fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'expandColumn', {
				groupKey,
				groupBy,
			});

			groupKey && setCollapsedColumns([groupKey], false);
		},
		[createAnalyticsEvent, groupKey, groupBy, setCollapsedColumns],
	);

	const collapseColumn = useCallback(() => {
		fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'collapseColumn', {
			groupKey,
			groupBy,
		});

		groupKey && setCollapsedColumns([groupKey], true);
	}, [createAnalyticsEvent, groupKey, groupBy, setCollapsedColumns]);

	return { collapseColumn, expandColumn };
};

export const useExpandVirtualCards = (isCollapsedColumn: boolean) => {
	/* HACK - delay virtual cards expanded to avoid the incorrect spacing between cards
    The totalSize is wrong calculated if we don't delay the expansion due to the animation */

	const [isCollapsed, setIsCollapsed] = useState(isCollapsedColumn);

	useEffect(() => {
		let expandColumnTimer: ReturnType<typeof setTimeout>;
		if (!isCollapsedColumn) {
			const oldIsCollapsed = isCollapsedColumn;
			/* Expand collapsed column after 100ms */
			expandColumnTimer = setTimeout(() => {
				if (!oldIsCollapsed && !isCollapsedColumn) {
					setIsCollapsed(false);
				}
			}, 100);
		} else {
			setIsCollapsed(true);
		}

		return () => {
			if (expandColumnTimer != null) clearTimeout(expandColumnTimer);
		};
	}, [isCollapsedColumn]);

	return { isCollapsed };
};
